// LiveStreamGiftDiamond.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Loading, { LoadingType } from '../component/Loading.jsx';
import { color } from '../style/variables.js';
import { Flip } from '../component/Flip.jsx';
import numberWithCommas from '../resource/numberWithCommas.js';
import formatNumber from '../resource/formatNumber.js';
import DiamondIconSrc from '../../img/point_2.svg';

export class LiveStreamGiftDiamond extends React.PureComponent {
  render() {
    const { giftDiamondCount } = this.props;
    return (
      <StyledLiveStreamGiftDiamond>
        <GiftDiamond>
          <DiamondIcon src={DiamondIconSrc} alt="diamond icon" />
          {giftDiamondCount === null && (
            <DiamondLoader>
              <Loading size={20} type={LoadingType.WHITE} />
            </DiamondLoader>
          )}
          {giftDiamondCount !== null && (
            <GiftDiamondWrapper>
              {giftDiamondCount >= 100000000 ? (
                formatNumber(giftDiamondCount, { maxSuffix: 'k' })
              ) : (
                <Flip>{numberWithCommas({ number: giftDiamondCount })}</Flip>
              )}
            </GiftDiamondWrapper>
          )}
        </GiftDiamond>
      </StyledLiveStreamGiftDiamond>
    );
  }
}

LiveStreamGiftDiamond.propTypes = {
  giftDiamondCount: PropTypes.number,
};

LiveStreamGiftDiamond.defaultProps = {
  giftDiamondCount: 0,
};

const StyledLiveStreamGiftDiamond = styled.div`
  width: auto;
  display: inline-flex;
  justify-content: center;
  color: ${color.tealBlue};
  font-size: 12px;
  font-weight: 600;
  line-height: 1.5;
`;

const DiamondLoader = styled.div`
  position: relative;
`;

const GiftDiamondWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const DiamondIcon = styled.img`
  margin-right: 2px;
  width: 14px;
  height: 14px;
  object-fit: contain;
`;

const GiftDiamond = styled.div`
  display: flex;
  align-items: center;
`;

export default LiveStreamGiftDiamond;
